module.exports = __webpack_public_path__ + "img/KSC05819.8b43db75.jpg";